import { initConfig } from '@shared/config/runtime.js';
import { env } from "./mixins/environment.js";
import CP_CONFIG from "@src/js/msp/config.js";
initConfig(env);
// Flag condivisi con il desktop (constants.php → src/js/msp/config.js, script cache:msp).
initConfig({
    DESCRIZIONE_AUTOMATICA: !!CP_CONFIG.DESCRIZIONE_AUTOMATICA,
    TURNSTILE_SITE_KEY: CP_CONFIG.TURNSTILE_SITE_KEY || '',
});

import Vue from "vue";
import Vuex from "vuex";

// Mock API interceptor (si attiva solo se VUE_APP_USE_MOCKS=true)
import './mocks';

import App from "./App.vue";
import VueForceNextTick from "vue-force-next-tick";
import vuetify from "./plugins/vuetify";
import router from "./router";
import "./registerServiceWorker";

import store from "./store";

import VCalendar from 'v-calendar';
import _storage from "@mixins/storage";

// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
  componentPrefix: 'vc',  // Use <vc-calendar /> instead of <v-calendar />
});




Vue.use(VueForceNextTick);
Vue.use(Vuex);
Vue.config.productionTip = false;
Vue.config.ignoredElements = [/^ion-/];
_storage.askAuthorization()
.then(()=>{
new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
});
